import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { routeNames } from '../../routes'
import './ToolDetailSidebar.sass'


class ToolDetailSidebar extends Component {
  render() {
    return (
      <section className="tool-detail-sidebar">
        <Link className="btn-blue-solid-sm" to={routeNames.filteredSearch}>back to results</Link>
        <div>
          <Link className="btn-blue-solid-sm" to={routeNames.guidedSearch}>guide new search</Link>
          <Link className="btn-blue-solid-sm" to={routeNames.filteredSearch}>view all tools</Link>
        </div>
      </section>
    )
  }
}

export default connect()(ToolDetailSidebar)
